/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform User Consent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Status of user consent
 * @export
 * @enum {string}
 */
export enum UserConsentStatusType {
    ConsentGiven = 'CONSENT_GIVEN',
    NoConsentGiven = 'NO_CONSENT_GIVEN'
}

export function UserConsentStatusTypeFromJSON(json: any): UserConsentStatusType {
    return UserConsentStatusTypeFromJSONTyped(json, false);
}

export function UserConsentStatusTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserConsentStatusType {
    return json as UserConsentStatusType;
}

export function UserConsentStatusTypeToJSON(value?: UserConsentStatusType | null): any {
    return value as any;
}

